// routes.js
import { Navigate } from "react-router-dom";
import Login from "../pages/Login/Login";
import Patient from "../pages/Patient/Patient";
import BroadcastNotification from "../pages/BroadcastNotification/BroadcastNotification";
import Doctor from "../pages/Doctors/Doctor";
import DoctorSpeciality from "../pages/DoctorSpeciality/DoctorSpeciality";
import InPersonAppointment from "../pages/InPersonAppointments/InPersonAppointments";
import Diet from "../pages/Diet/Diet";
import DietMealPlan from "../pages/DietMealPlan/DietMealPlan";
import DietMealPlanReview from "../pages/DietMealPlanReview/DietMealPlanReview";
import MasterFood from "../pages/MasterFood/MasterFood";
import DietFeedback from "../pages/DietFeedback/DietFeedback";
import DietPromptManagement from "../pages/Diet/DietPromptManagement";
import DietConfigurationManagement from "../pages/Diet/DietConfigurationManagement";
import DietSystemOverview from "../pages/Diet/DietSystemOverview";
import LowFodmapDiet from "../pages/Diet/LowFodmapDiet";
import LowFodmapDashboard from "../pages/Diet/LowFodmapDashboard";
import LowFodmapTestingFoods from "../pages/Diet/LowFodmapTestingFoods";
import LowFodmapPrompts from "../pages/Diet/LowFodmapPrompts";
import Brain from "../pages/Gut/Gut";
import BlogCategories from "../pages/BlogCategories/BlogCategories";
import BlogSubCategories from "../pages/BlogSubCategories/BlogSubCategories";
import DietSubCategories from "../pages/DietSubCategories/DietSubCategories";
import GutSubCategories from "../pages/GutSubCategories/GutSubCategories";
import BlogContent from "../pages/BlogContent/BlogContent";
import FAQ from "../pages/FAQ/FAQ";
import Reports from "../pages/Reports/Reports";
import DietCategories from "../pages/DietCategories/DietCategories";
import GutCategories from "../pages/GutCategories/GutCategories";
import Stats from "../pages/Stats/Stats";
import Feedback from "../pages/Feedback/Feedback";
import YogaModule from "../pages/YogaModule/YogaModule";
import VideoModule from "../pages/YogaModule/VideoModule";
import WebsiteHomePage from "../pages/Website/Home"
import WebsiteHomeCarousel from "../pages/Website/HomeCarousel"
import WebsiteHomeBrandLogos from "../pages/Website/HomeBrandLogos"
import WebsiteAboutUploadVideos from "../pages/Website/about/UploadVideos"
import WebsiteAboutUploadLogos from "../pages/Website/about/UploadLogos"
import WebsiteAboutHeroSection from "../pages/Website/about/HeroSection"
import WebsiteUserQueries from "../pages/Website/UserQueries"
import WebsiteUserInfo from "../pages/Website/UserInfo"
import WebsiteEnrollDoctor from "../pages/Website/EnrollDoctor"
import WebsiteUserTestimonial from "../pages/Website/UserTestimonial"
import DoctorTestimonial from "../pages/Website/DoctorTestimonial";
import WebsiteUploadVideo from "../pages/Website/UploadVideo"
import WebsiteBlogs from "../pages/Website/Blogs"
import WebsiteWebinarEvents from "../pages/Website/WebinarEvents"
import WebsiteTeams from "../pages/Website/Teams"
import WebsiteQNA from "../pages/Website/QNA"
// import DietMealPlan from "../pages/DietMealPlan/DietMealPlan";
import Questions from "../pages/CBT/Questions";
import Options from "../pages/CBT/Options";
import DassQuestions from "../pages/CBT/DassQuestions";
// import TaskManagement from "../pages/CBT/TaskManagement";
// import TaskManagementNew from "../pages/CBT/TaskManagementNew";
import UserTaskAssignment from "../pages/CBT/UserTaskAssignment";
import CbtTasks from "../pages/CBT/CbtTasks";
import PromptManagement from "../pages/Prompts/PromptManagement";
import SessionSummaries from "../pages/CBT/SessionSummaries";
import JournalCategories from "../pages/Journal/JournalCategories";
import JournalResponses from "../pages/Journal/JournalResponses";
import PatientTaskCompletion from "../pages/CBT/PatientTaskCompletion";
import CbtContent from "../pages/CBT/CbtContent";
import CbtAnalytics from "../pages/CBT/CbtAnalytics";
import Dashboard from "../pages/Dashboard/Dashboard";
// import Vendors from "../pages/Vendors/Vendors";
// import Admins from "../pages/Admins/Admins";
// import Events from "../pages/Events/Events";
// import Subscriptions from "../pages/Subscriptions/Subscriptions";
// import Payments from "../pages/Payments/Payments";
// import VenueFeatures from "../pages/VenueFeatures/VenueFeatures";
// import Amenities from "../pages/Amenities/Amenities";
// import Banners from "../pages/Banners/Banners";
// import Venues from "../pages/Venues/Venues";
// import TokenPoints from "../pages/Tokens/TokenPoints";
// import OfflineAddon from "../pages/OfflineAddon/OfflineAddon";
// import Addons from "../pages/Addon/Addons";
// import Actionables from "../pages/Actionables/Actionables";

function PrivateRoute({ children }) {
  const auth = localStorage.getItem("token");
  return auth ? children : <Navigate to="/login" />;
}

function PublicRoute({ children }) {
  const auth = localStorage.getItem("token");
  return !auth ? children : <Navigate to="/" />;
}

const routes = [
  {
    path: "/",
    component: (
      <PrivateRoute>
        <Dashboard />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/login",
    component: (
      <PublicRoute>
        <Login />
      </PublicRoute>
    ),
    isPrivate: false,
  },
  //   {
  //     path: "/register",
  //     component: (
  //       <PublicRoute>
  //         <Register />
  //       </PublicRoute>
  //     ),
  //     isPrivate: false,
  //   },
  {
    path: "/dashboard",
    component: (
      <PrivateRoute>
        <Dashboard />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/Patient",
    component: (
      <PrivateRoute>
        <Patient />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/broadcast-notification",
    component: (
      <PrivateRoute>
        <BroadcastNotification />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/doctor",
    component: (
      <PrivateRoute>
        <Doctor />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/doctorSpeciality",
    component: (
      <PrivateRoute>
        <DoctorSpeciality />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/inpersonappointment",
    component: (
      <PrivateRoute>
        <InPersonAppointment />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/diet",
    component: (
      <PrivateRoute>
        <Diet />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/DietMealPlan",
    component: (
      <PrivateRoute>
        <DietMealPlan />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/diet-meal-plan-review",
    component: (
      <PrivateRoute>
        <DietMealPlanReview />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/MasterFood",
    component: (
      <PrivateRoute>
        <MasterFood />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/diet-feedback",
    component: (
      <PrivateRoute>
        <DietFeedback />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/brain",
    component: (
      <PrivateRoute>
        <Brain />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/blogContnent",
    component: (
      <PrivateRoute>
        <BlogContent />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/faq",
    component: (
      <PrivateRoute>
        <FAQ />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/reports",
    component: (
      <PrivateRoute>
        <Reports />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/blogcategories",
    component: (
      <PrivateRoute>
        <BlogCategories />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/blogsubcategories",
    component: (
      <PrivateRoute>
        <BlogSubCategories />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/dietcategories",
    component: (
      <PrivateRoute>
        <DietCategories />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/dietsubcategories",
    component: (
      <PrivateRoute>
        <DietSubCategories />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/diet-prompts",
    component: (
      <PrivateRoute>
        <DietPromptManagement />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/diet-configurations",
    component: (
      <PrivateRoute>
        <DietConfigurationManagement />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/diet-system-overview",
    component: (
      <PrivateRoute>
        <DietSystemOverview />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/low-fodmap-diet",
    component: (
      <PrivateRoute>
        <LowFodmapDiet />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/diet/low-fodmap",
    component: (
      <PrivateRoute>
        <LowFodmapDashboard />
      </PrivateRoute>
    ),
    isPrivate: true,
  },
  {
    path: "/diet/low-fodmap/testing-foods",
    component: (
      <PrivateRoute>
        <LowFodmapTestingFoods />
      </PrivateRoute>
    ),
    isPrivate: true,
  },
  {
    path: "/diet/low-fodmap/prompts",
    component: (
      <PrivateRoute>
        <LowFodmapPrompts />
      </PrivateRoute>
    ),
    isPrivate: true,
  },
  {
    path: "/cbtquestion",
    component: (
      <PrivateRoute>
        <Questions />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/cbtdassquestion",
    component: (
      <PrivateRoute>
        <DassQuestions />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/cbtoptions",
    component: (
      <PrivateRoute>
        <Options />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/cbt-tasks",
    component: (
      <PrivateRoute>
        <CbtTasks />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  // {
  //   path: "/cbt-task-management",
  //   component: (
  //     <PrivateRoute>
  //       <TaskManagement />
  //     </PrivateRoute>
  //   ),
  //   isPrivate: false,
  // },
  // {
  //   path: "/cbt-task-management-new",
  //   component: (
  //     <PrivateRoute>
  //       <TaskManagementNew />
  //     </PrivateRoute>
  //   ),
  //   isPrivate: false,
  // },
  {
    path: "/user-task-assignment",
    component: (
      <PrivateRoute>
        <UserTaskAssignment />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/gutsubcategories",
    component: (
      <PrivateRoute>
        <GutSubCategories />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/yogamodule",
    component: (
      <PrivateRoute>
        <YogaModule />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/yogamodule/videomodule",
    component: (
      <PrivateRoute>
        <VideoModule />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/gutcategories",
    component: (
      <PrivateRoute>
        <GutCategories />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/stats",
    component: (
      <PrivateRoute>
        <Stats />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/feedback",
    component: (
      <PrivateRoute>
        <Feedback />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  //   {
  //     path: "/vendors",
  //     component: (
  //       <PrivateRoute>
  //         <Vendors />
  //       </PrivateRoute>
  //     ),
  //     isPrivate: false,
  //   },
  //   {
  //     path: "/admins",
  //     component: (
  //       <PrivateRoute>
  //         <Admins />
  //       </PrivateRoute>
  //     ),
  //     isPrivate: false,
  //   },
  //   {
  //     path: "/events",
  //     component: (
  //       <PrivateRoute>
  //         <Events />
  //       </PrivateRoute>
  //     ),
  //     isPrivate: false,
  //   },
  //   {
  //     path: "/venues",
  //     component: (
  //       <PrivateRoute>
  //         <Venues />
  //       </PrivateRoute>
  //     ),
  //     isPrivate: false,
  //   },
  //   {
  //     path: "/subscriptions",
  //     component: (
  //       <PrivateRoute>
  //         <Subscriptions />
  //       </PrivateRoute>
  //     ),
  //     isPrivate: false,
  //   },
  //   {
  //     path: "/payments",
  //     component: (
  //       <PrivateRoute>
  //         <Payments />
  //       </PrivateRoute>
  //     ),
  //     isPrivate: false,
  //   },
  //   {
  //     path: "/token-points",
  //     component: (
  //       <PrivateRoute>
  //         <TokenPoints />
  //       </PrivateRoute>
  //     ),
  //     isPrivate: false,
  //   },

  //   {
  //     path: "/venue-features",
  //     component: (
  //       <PrivateRoute>
  //         <VenueFeatures />
  //       </PrivateRoute>
  //     ),
  //     isPrivate: false,
  //   },
  //   {
  //     path: "/amenities",
  //     component: (
  //       <PrivateRoute>
  //         <Amenities />
  //       </PrivateRoute>
  //     ),
  //     isPrivate: false,
  //   },
  //   {
  //     path: "/banners",
  //     component: (
  //       <PrivateRoute>
  //         <Banners />
  //       </PrivateRoute>
  //     ),
  //     isPrivate: false,
  //   },
  //   {
  //     path: "/addons",
  //     component: (
  //       <PrivateRoute>
  //         <Addons />
  //       </PrivateRoute>
  //     ),
  //     isPrivate: false,
  //   },
  //   {
  //     path: "/offline-addon",
  //     component: (
  //       <PrivateRoute>
  //         <OfflineAddon />
  //       </PrivateRoute>
  //     ),
  //     isPrivate: false,
  //   },
  //   {
  //     path: "/admin-actionables",
  //     component: (
  //       <PrivateRoute>
  //         <Actionables />
  //       </PrivateRoute>
  //     ),
  //     isPrivate: false,
  //   },
  {
    path: "/homepage",
    component: (
      <PrivateRoute>
        <WebsiteHomePage />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/homepage/carousel",
    component: (
      <PrivateRoute>
        <WebsiteHomeCarousel />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/homepage/brand-logos",
    component: (
      <PrivateRoute>
        <WebsiteHomeBrandLogos />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/about/uploadvideos",
    component: (
      <PrivateRoute>
        <WebsiteAboutUploadVideos />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/about/uploadlogos",
    component: (
      <PrivateRoute>
        <WebsiteAboutUploadLogos />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/about/herosection",
    component: (
      <PrivateRoute>
        <WebsiteAboutHeroSection />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/userqueries",
    component: (
      <PrivateRoute>
        <WebsiteUserQueries />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/gut-score-enquiry",
    component: (
      <PrivateRoute>
        <WebsiteUserInfo />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/enrolldoctor",
    component: (
      <PrivateRoute>
        <WebsiteEnrollDoctor />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/usertestimonial",
    component: (
      <PrivateRoute>
        <WebsiteUserTestimonial />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/doctortestimonial",
    component: (
      <PrivateRoute>
        <DoctorTestimonial />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/uploadvideo",
    component: (
      <PrivateRoute>
        <WebsiteUploadVideo />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/blogs",
    component: (
      <PrivateRoute>
        <WebsiteBlogs />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/webinarevents",
    component: (
      <PrivateRoute>
        <WebsiteWebinarEvents />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/teams",
    component: (
      <PrivateRoute>
        <WebsiteTeams />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/q&a",
    component: (
      <PrivateRoute>
        <WebsiteQNA />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/prompts",
    component: (
      <PrivateRoute>
        <PromptManagement />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/journal-categories",
    component: (
      <PrivateRoute>
        <JournalCategories />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/journal-responses",
    component: (
      <PrivateRoute>
        <JournalResponses />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/cbt-session-summaries",
    component: (
      <PrivateRoute>
        <SessionSummaries />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/patient-task-completion",
    component: (
      <PrivateRoute>
        <PatientTaskCompletion />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/cbt-content",
    component: (
      <PrivateRoute>
        <CbtContent />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
  {
    path: "/cbt-analytics",
    component: (
      <PrivateRoute>
        <CbtAnalytics />
      </PrivateRoute>
    ),
    isPrivate: false,
  },
];

export default routes;
